var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',[_vm._v("Welcome "+_vm._s(_vm.user.name)+" To Your Dashboard")])
}
var staticRenderFns = []

export { render, staticRenderFns }